import styled from 'styled-components';
import { H3 } from 'components/Typography';
import { FiCheck } from 'react-icons/fi';

import DefaultSpinner from 'components/Spinner';
import DefaultButton from 'components/Buttons/Button';

export const Container = styled.div`
  margin-bottom: 6.1875rem;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`;

export const Title = styled(H3)`
  margin-bottom: 1rem;
`;

// TODO: TFR-44 move to container group
export const Section = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const Types = styled.div`
  display: flex;
`;

export const ReportType = styled(DefaultButton)`
  background-color: ${({ theme }) => theme.colors.white};
  &.selected {
    border: 0.0625rem solid ${({ theme }) => theme.colors.greenDark};
    color: ${({ theme }) => theme.colors.greenDark};
  }
  :not(:last-child) {
    margin-right: 1rem;
  }
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 2.5rem 2rem;
  border-radius: 1.5rem;
  font-size: 1.2rem;
`;

export const Button = styled(DefaultButton)`
  text-transform: uppercase;
  margin-top: 2rem;
`;

export const ListWrapper = styled.div`
  margin: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 50%;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckIcon = styled(FiCheck)`
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
  color: ${({ theme }) => theme.colors.greenDark};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Spinner = styled(DefaultSpinner)``;
